webpackJsonp([196074945376866],{

/***/ 151:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _BannerLanding = __webpack_require__(5);
	
	var _BannerLanding2 = _interopRequireDefault(_BannerLanding);
	
	var _BannerSection = __webpack_require__(6);
	
	var _BannerSection2 = _interopRequireDefault(_BannerSection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Donations = function Donations(props) {
	  var _props$data$contentfu = props.data.contentfulDonations,
	      title = _props$data$contentfu.title,
	      metaDescription = _props$data$contentfu.metaDescription,
	      headerBackgroundImage = _props$data$contentfu.headerBackgroundImage,
	      sectionFourHeading = _props$data$contentfu.sectionFourHeading,
	      sectionFourContent = _props$data$contentfu.sectionFourContent;
	
	
	  return _react2.default.createElement(
	    'div',
	    { id: 'main', className: 'alt-colors' },
	    _react2.default.createElement(_BannerLanding2.default, {
	      title: title,
	      desc: metaDescription,
	      bg: headerBackgroundImage !== null ? headerBackgroundImage.file.url : undefined
	    }),
	    _react2.default.createElement(
	      'section',
	      { id: 'section-four' },
	      _react2.default.createElement(
	        'div',
	        { className: 'inner' },
	        _react2.default.createElement(
	          'header',
	          null,
	          _react2.default.createElement(_BannerSection2.default, { sectionContent: sectionFourHeading })
	        ),
	        sectionFourContent !== null ? _react2.default.createElement('div', {
	          dangerouslySetInnerHTML: {
	            __html: sectionFourContent.childMarkdownRemark.html
	          }
	        }) : undefined
	      )
	    ),
	    _react2.default.createElement('hr', null)
	  );
	}; // eslint-disable-line import/no-extraneous-dependencies
	// import YouTube from 'react-youtube'
	
	
	Donations.propTypes = {
	  data: _propTypes2.default.object.isRequired
	};
	
	exports.default = Donations;
	module.exports = exports['default'];

/***/ }),

/***/ 184:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.newsletterQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(4);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Donations = __webpack_require__(151);
	
	var _Donations2 = _interopRequireDefault(_Donations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DonationsPage = function DonationsPage(props) {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      null,
	      _react2.default.createElement(
	        'title',
	        null,
	        'Donations | ' + props.data.site.siteMetadata.title
	      ),
	      _react2.default.createElement('meta', {
	        name: 'description',
	        content: props.data.contentfulDonations.metaDescription
	      })
	    ),
	    _react2.default.createElement(_Donations2.default, { data: props.data })
	  );
	};
	
	// components
	// eslint-disable-line import/no-extraneous-dependencies
	
	
	DonationsPage.propTypes = {
	  data: _propTypes2.default.object.isRequired
	};
	
	exports.default = DonationsPage;
	var newsletterQuery = exports.newsletterQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-donations-js-7e84170a6e8f8b1cc594.js